export const COMMENTS_SECTION_ID = 'comments';
